/**
 * הערכים של משימה, כפי שהחלון עובד איתם.
 *
 * בקובץ נפרד מהרכיב כדי שקובץ של רכיב ייצא רכיבים בלבד.
 */
export type TaskValues = {
  id: string | null;
  title: string;
  description: string;
  branchId: string;
  assigneeId: string;
  priorityId: string;
  /** yyyy-MM-ddTHH:mm, או ריק. רק למשימה חד פעמית. */
  dueAt: string;
  requiresPhoto: boolean;
  /** התראה למי שהטיל אותה, כשהיא מסומנת כבוצעה. */
  notifyOnComplete: boolean;
  /** 'once' = משימה רגילה. השאר = תבנית חוזרת. */
  repeat: TaskRepeat;
  weekdays: number[];
  dayOfMonth: number | null;
  /** HH:MM, רק לחוזרת. ריק = עד סוף היום. */
  dueTime: string;
  /** מזהה התבנית החוזרת, כשעורכים אותה ולא משימה בודדת. */
  scheduleId: string | null;
};

export type TaskRepeat = 'once' | 'daily' | 'weekly' | 'monthly';

export const REPEAT_LABEL: Record<TaskRepeat, string> = {
  once: 'פעם אחת',
  daily: 'כל יום',
  weekly: 'בימים קבועים בשבוע',
  monthly: 'פעם בחודש',
};

export const EMPTY_TASK: TaskValues = {
  id: null,
  title: '',
  description: '',
  branchId: '',
  assigneeId: '',
  priorityId: '',
  dueAt: '',
  requiresPhoto: false,
  notifyOnComplete: false,
  repeat: 'once',
  weekdays: [],
  dayOfMonth: null,
  dueTime: '',
  scheduleId: null,
};
